module.exports = __webpack_public_path__ + "img/pop_wallet_logo_phantom@2x.474759e9.png";